import { type DeepPartial } from '@direct-frontend/stdlib';
import { type PromoactionModel } from './types';

export const getPromoactionTargetText = (promoaction: DeepPartial<PromoactionModel>): string => {
    if (promoaction?.validity?.isFirstOrderOnly === 'true') {
        return 'Только к первому заказу покупателя';
    }

    return 'Ко всем заказам';
};
